module.exports = __webpack_public_path__ + "static/epic-8fb024338be34178123b614c273bc474.jpg";